import React, {useContext} from 'react';
import {withRouter} from 'react-router-dom';

const RouterContext = React.createContext({
  //TODO: better mock values
  location: null,
  history: null,
  match: null,
});

export const ProvideRoutes = withRouter(
  function({children, location, history, match}) {
    return <RouterContext.Provider value={{location, history, match}}>
      {children}
      </RouterContext.Provider>;
  }
);

export function useRoutes() {
  return useContext(RouterContext);
}



// WEBPACK FOOTER //
// ./modules/issFrontend/hooks/useRoutes.jsx